import * as variables from './variables.js';

import * as $ from 'jquery';

import { Analytics } from '@plaudit/analytics';
Analytics.getInstance();

// Mobile nav
const $nav = $('.navbar-nav');
$('.navbar-toggle').on('click', function() {
	$nav.slideToggle('slow');
});

// Enable cross domain on forms. We need this because of FormStack
$(document).on('submit', function() {
	const win = window as any;
	if (win.ga !== undefined) {
		win.ga('linker:decorate', this);
	}
});

// @ts-ignore
require('./site/DynamicForm.js').init();
